











//
// WARNING
// This file is auto-generated by Queries.tst
// Don't try to edit it, your changes will be lost.
// If you nedd to change this file, edit Queries.tst.
//

import { Type, Transform } from "class-transformer";
import { CancelToken } from 'axios'
import * as moment from 'moment'
import * as qrs from '@/modules/qrs'

import {
    Query,
    IPaginatedQuery, SearchDirection, ProtectedMemory,
    QueryExecutor, PaginatedQueryExecutor
} from '@/modules/qrs'

import {
    IOrderableQuery, IOrderByDescriptor, IOrderBySelectorFn, OrderByConfig, IOrderableProperties,
    OrderableQueryExecutor, OrderablePaginatedQueryExecutor
} from '@/modules/qrs/extensions/orderable'


    

    @Query('CurrentDashboardSelectedQuery')
    
    export class CurrentDashboardSelectedQuery implements IPaginatedQuery {
        constructor( dashboardId: number ) {
            
                this.dashboardId = dashboardId;
            
        }

        
            
            public dashboardId: number;
        

        

        
            /**
            *   Sets the direction of the pager.
            */
            public direction: SearchDirection = SearchDirection.Next;

            /**
            *   Sets the number of items per page.
            */
            public perPage: number = 10;
        

        
            /**
            * Returns an instance of a simple QueryExecutor for this query.
            */
            public static getExecutor( query?: CurrentDashboardSelectedQuery ) {
                return new QueryExecutor<CurrentDashboardSelectedQuery, CurrentDashboardSelectedQueryResult>(CurrentDashboardSelectedQueryResult, query);
            }

            

            
                /**
                * Returns an instance of a paginated QueryExecutor for this query.
                */
                public static getPaginatedExecutor( query?: CurrentDashboardSelectedQuery ) {
                    return new PaginatedQueryExecutor<CurrentDashboardSelectedQuery, CurrentDashboardSelectedQueryResult>(CurrentDashboardSelectedQueryResult, query);
                }

                
            
        
    }

    

    
        /**
        * The result model for CurrentDashboardSelectedQuery.
        */
        export class CurrentDashboardSelectedQueryResult {
            
                
                 dashboardId: number;
            
                
                 name: string;
            
                
                 grantLevel: number;
            
                
                 sensors: string;
            
                
                 config: string;
            
        }
    

    /**
    * Extraneous types
    */
    export namespace CurrentDashboardSelectedQuery.ExtraneousTypes {
        

        
    }

